module.exports = __webpack_public_path__ + "static/media/text-book.337d2845.svg";